import { render, staticRenderFns } from "./Anticrisis.vue?vue&type=template&id=5bbae3f4&"
import script from "./Anticrisis.vue?vue&type=script&lang=js&"
export * from "./Anticrisis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports